import styled from 'styled-components';

export const EditContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 30px 35px;
  max-width: 94vw;

  @media (max-width: 1350px) {
    width: 70vw;
  }
`;

export const EditSectionLeft = styled.div`
  min-width: 620px;
`;

export const FilterSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 0.5fr 0.5fr;
  grid-gap: 0 10px;
  margin-bottom: 10px;
`;

export const EditFooter = styled.div`
  display: flex;
  justify-content: space-between;
  @media (max-width: 1350px) {
    overflow: auto;
  }
`;

export const EditWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  @media (max-width: 1350px) {
    display: block;
    overflow: auto;
  }
`;

export const EditSectionRight = styled.div`
  background-color: #fbfcfd;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  width: auto;
  min-width: 620px;
  margin-left: 25px;
  @media (max-width: 1350px) {
    margin-left: 0px;
  }
`;

export const EditFooterLeftBtns = styled.div`
  display: flex;
`;

export const EditFooterRightBtns = styled.div`
  display: flex;
`;

export const TeamBasicInfo = styled.div`
  border-bottom: 1px solid #e5e5e5;
  display: flex;
  padding: 25px 25px 20px 25px;
`;

export const FormField = styled.div``;

export const AddLogoButton = styled.button`
  border-radius: 4px;
  border: 0;
  padding: 5px;
  display: none;
  flex-direction: column;
  align-items: center;
`;

export const BadgeWrapper = styled.div`
  &:hover ${AddLogoButton} {
    display: flex;
  }
`;

export const AddLogoButtonWrapper = styled.div`
  position: absolute;
  top: 24px;
  left: 50%;
  margin-left: -30px;
`;

export const AddLogoButtonText = styled.span`
  color: #8a91a6;
  font-size: 9px;
  text-transform: uppercase;
`;

export const FilterCounter = styled.div`
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  display: flex;
`;

export const FilterCounterTiTle = styled.span`
  color: #5d6e81;
  font-size: 20px;
`;

export const FilterSelectedCounter = styled.div`
  border-bottom: 1px solid #e5e5e5;
  justify-content: space-evenly;
  align-items: center;
  padding: 40px 0;
  display: flex;
`;

export const FilterSelectedPills = styled.div`
  display: flex;
  justify-content: center;
  margin: 10px 0;
`;

export const DeleteModal = styled.div`
  justify-content: flex-end;
  display: flex;
  margin: 20px;
`;

export const Content = styled.div`
  float: left;
  width: 50%;
  height: 500px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;

  & > h1 {
    height: 60px;
    width: 164px;
    color: #7f8b99;
    font-family: 'Baloo Thambi 2';
    font-size: 19px;
    letter-spacing: 0.47px;
    line-height: 20px;
    text-align: center;
    font-weight: 400;
    position: relative;
    right: 154px;
    top: 53px;
  }
`;

export const Arrow = styled.div`
  position: relative;
  margin: 0 auto;
  width: 100px;
  -moz-transform: rotate(90deg) scale(-1, 1);
  -ms-transform: rotate(90deg) scale(-1, 1);
  -webkit-transform: rotate(90deg) scale(-1, 1);
  transform: rotate(90deg) scale(-1, 1);
`;

export const Curve = styled.div`
  border: 2px solid #bac1c9;
  opacity: 0.44;
  border-color: transparent transparent transparent #bac1c9;
  height: 361px;
  width: 1200px;
  border-radius: 307px 0 0 4px;
  zindex: -9999;
`;

export const Point = styled.div`
  position: absolute;
  left: 40px;
  top: 315px;

  &:before,
  &:after {
    border: 1px solid #bac1c9;
    height: 12px;
    content: '';
    position: absolute;
    opacity: 0.44;
  }

  &:before {
    top: 35px;
    left: -45px;
    -webkit-transform: rotate(-38deg);
    -ms-transform: rotate(-38deg);
    transform: rotate(-38deg);
    -webkit-transform: rotate(-38deg);
    -moz-transform: rotate(-38deg);
    -ms-transform: rotate(-38deg);
  }

  &:after {
    top: 34px;
    left: -35px;
    -webkit-transform: rotate(31deg);
    -ms-transform: rotate(31deg);
    transform: rotate(31deg);
    -webkit-transform: rotate(31deg);
    -moz-transform: rotate(31deg);
    -ms-transform: rotate(31deg);
  }
`;
